import {SearchField} from '@wandb/components';
import React, {type FC} from 'react';

import {DD_PRIVACY_ALLOW} from '../../util/datadog/privacy';
import {useJSONTreeSearchInputContext} from './JSONTreeSearchContextProvider';

export const SearchInput: FC = () => {
  const {searchQuery, onChangeSearchQuery} = useJSONTreeSearchInputContext();

  return (
    <div data-dd-privacy={DD_PRIVACY_ALLOW}>
      <SearchField
        fullWidth
        aria-label="search keys with regex"
        placeholder="Search keys with regex"
        value={searchQuery}
        onChange={onChangeSearchQuery}
      />
    </div>
  );
};
